<template>
  <div
    class="sign-in-banner-container columns is-mobile"
    data-analytics-id="homepage-container"
    data-analytics-label="BeautyPass"
  >
    <div class="sign-in-banner column is-7-desktop">
      <nuxt-img
        :src="$options.locals.loyaltyJoin"
        :alt="$t('layout.signInBanner.loyaltyJoin')"
        class="loyalty-join-icon"
      />
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="beauty-pass-text has-text-left-desktop is-size-5-desktop"
        v-html="
          $t('layout.signInBanner.becomeMember', {
            beautyPass: `<b>${$t('layout.signInBanner.beautyPass')}</b>`
          })
        "
      />
      <!--eslint-enable-->
      <Button
        :label="$t('layout.signInBanner.register')"
        url="/sign_in"
        class="banner-btn"
        data-analytics-id="homepage-link"
        data-analytics-action="sign-in"
        data-analytics-label="/sign_in"
        @click="trackRegisterClicked"
      />
    </div>
    <div class="column sign-in-banner">
      <nuxt-img
        :src="$options.locals.sephoraFlame"
        :alt="$t('layout.signInBanner.sephoraFlame')"
        class="flame-icon"
      />
      <div class="beauty-pass-text has-text-left-desktop is-size-5-desktop">
        <div class="has-text-weight-bold">
          {{ $t('layout.signInBanner.alreadyMember') }}
        </div>
        <div>
          {{ $t('layout.signInBanner.signInText') }}
        </div>
      </div>
      <Button
        :label="$t('layout.signInBanner.signIn')"
        url="/sign_in"
        class="banner-btn"
        data-analytics-id="homepage-link"
        data-analytics-action="sign-in"
        data-analytics-label="/sign_in"
        @click="trackSignInClicked"
      />
    </div>
  </div>
</template>

<script>
import Button from '@sephora-asia/core-button/Button.vue'
import loyaltyJoin from '../images/loyalty-join.png'
import sephoraFlame from '../images/sephora-flame-icon.svg'
import impressionTracking from '@sephora-asia/common-ui/mixins/impressionTracking.js'

export default {
  name: 'SignInBanner',
  components: {
    Button
  },
  mixins: [impressionTracking],
  locals: {
    loyaltyJoin,
    sephoraFlame
  },
  methods: {
    trackRegisterClicked() {
      this.$analytics.trackEvent('homepage_click_beauty_pass_register')
    },
    trackSignInClicked() {
      this.$analytics.trackEvent('homepage_click_beauty_pass_signin')
    },
    trackImpression() {
      this.$analytics.trackEvent('homepage_impression_beauty_pass')
    }
  }
}
</script>

<style scoped lang="scss">
.sign-in-banner-container {
  width: 100%;
  background: $grey-light;
  margin-top: 16px;
  margin-bottom: 24px;
  margin-left: 0;
  margin-right: 0;
}

.loyalty-join-icon {
  width: 130px;
  height: 50px;
  margin-bottom: 9px;
}

.sign-in-banner {
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 0px 10px;

  &:not(:last-child) {
    border-right: 1px solid $grey;
  }
}

.beauty-pass-text {
  font-family: 'Sephora Serif', Palatino, Georgia, Times;
  font-size: 12px;
  padding-bottom: 10px;
}

@include desktop {
  .beauty-pass-text {
    padding-bottom: 0px;
    padding-left: 15px;
    padding-right: 10px;
  }

  .loyalty-join-icon {
    margin-bottom: 0px;
  }

  .sign-in-banner {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0px 15px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}

.flame-icon {
  width: 40px;
  height: 40px;
}

.banner-btn {
  @include mobile {
    width: 100%;
  }
  @include tablet-only {
    min-width: 155px;
  }
}
</style>
